import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
} from '@material-ui/core';

import useStyles from './styles';
import { Close } from '@material-ui/icons';

const Modal = ({
  open,
  onClose,
  children,
  title,
  onAction,
  titleAction,
  titleCancel,
  scroll,
  hideCancelButton,
  ...props
}: any) => {
  const classes = useStyles(props);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll ? scroll : 'paper'}
      maxWidth='lg'
    >
      <div className={classes.paper}>
        <IconButton
          className={classes.buttomClose}
          edge='start'
          aria-label='cerrar'
          onClick={onClose}
        >
          <Close color='action' />
        </IconButton>
        {title && (
          <DialogTitle className={classes.title} disableTypography>
            {title}
          </DialogTitle>
        )}

        <DialogContent className={classes.content}>{children}</DialogContent>
        {onAction && (
          <DialogActions className={classes.buttons}>
            {!hideCancelButton && (
              <Button
                disableRipple
                disableFocusRipple
                onClick={onClose}
                className={classes.buttom}
                size='medium'
                variant='text'
              >
                {titleCancel ? `${titleCancel}` : `Cancelar`}
              </Button>
            )}
            <Button
              size='medium'
              color='secondary'
              variant='contained'
              onClick={onAction}
            >
              {titleAction ? titleAction : title}
            </Button>
          </DialogActions>
        )}
      </div>
    </Dialog>
  );
};

export default Modal;
